import { render, staticRenderFns } from "./companyList.vue?vue&type=template&id=dfc64a50&scoped=true&"
import script from "./companyList.vue?vue&type=script&lang=js&"
export * from "./companyList.vue?vue&type=script&lang=js&"
import style0 from "./companyList.vue?vue&type=style&index=0&id=dfc64a50&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc64a50",
  null
  
)

export default component.exports